import { ElNotification } from "element-plus";

// TODO: add notifications log
export const showNotification = (title: string, message: string, level: NotificationLevel) => {
    ElNotification({
        title: title,
        message: message,
        type: level as string
    })
}

export enum NotificationLevel {
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info',
    ERROR = 'error',
    PRIMARY = 'primary'
}